import { Platform } from "../types/Platforms";
import { Product } from "../stores/appReportsStore";
import { format as dfnsFormat } from 'date-fns';
import { FilterOption } from "../stores/appUserDefaultStore";
import { logoTreatments, LogoTreatment } from "./logoTreatments.generated";


export function getPerUnitString(unit: string): string {
    const u = unit.toLowerCase();
    if (u === 'g' || u === 'gr') return 'kg';
    if (u === 'ml') return 'l';
    if (u === 'stucks') return 'stuk';
    if (u === 'pieces') return 'piece';
    return u;
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
});

const logoMap: Record<Platform,string> = {
    [Platform.BIDFOOD]: '/suppliers/bidfood_logo_nobg.png',
    [Platform.GNB]: '/suppliers/gnb_logo_nobg.png',
    [Platform.DZW]: '/suppliers/dzw_logo.jpeg',
    [Platform.VANGELDER]: '/suppliers/vangelder_logo_nobg.png',
    [Platform.SLIGRO]: '/suppliers/sligro_logo.png',
    [Platform.DUNYONG]: '/suppliers/dun_yong_logo.png',
    [Platform.TONKONIJN]: '/suppliers/tonkonijn_logo.png',
    [Platform.YAMA]: '/suppliers/yama_logo.png',
    [Platform.BANKETBAKKERIJ]: '/suppliers/banketbakkerij_logo.png',
    [Platform.OTELLI]: '/suppliers/otelli_logo.png',
    [Platform.JONGVADER]: '/suppliers/jong_vader_logo.png',
    [Platform.GEBOGELATO]: '/suppliers/gebogelato_logo.png',
    [Platform.KWASTWIJNKOPERS]: '/suppliers/kwastwijnkopers_logo.png',
    [Platform.VINVIN]: '/suppliers/vinvin_logo.png',
    [Platform.NICETOMEAT]: '/suppliers/nicetomeat_logo.png',
    [Platform.FIXFISCH]: '/suppliers/fixfisch_logo.png',
    [Platform.RUNGIS]: '/suppliers/rungis_logo.png',
    [Platform.CHEFSFARM]: '/suppliers/chefsfarm_logo.png',
    [Platform.HANOS]: '/suppliers/hanos_logo.png',
    [Platform.RIJPELAAL]: '/suppliers/rijpelaal_logo.png',
    [Platform.ZUIVER]: '/suppliers/zuiver_logo.png',
    [Platform.DEBERGSECAVE]: '/suppliers/debergsecave_logo.png',
    [Platform.HYSCON]: '/suppliers/hyscon_logo.png',
    [Platform.RIJNMONDGAS]: '/suppliers/rijnmondgas_logo.png',
    [Platform.WINTERHALTER]: '/suppliers/winterhalter_logo.png',
    [Platform.EUROFINS]: '/suppliers/eurofins_logo.png',
    [Platform.KOELMONTEUR]: '/suppliers/koelmonteur_logo.png',
    [Platform.BRANDINGCLUB]: '/suppliers/brandingclub_logo.png',
    [Platform.WHISKEYSITE]: '/suppliers/whiskysite_logo.png',
    [Platform.EVIDES]: '/suppliers/evides_logo.png',
    [Platform.UPTA]: '/suppliers/upta_logo.png',
    [Platform.WINTAX]: '/suppliers/wintax_logo.png',
    [Platform.VERISURE]: '/suppliers/verisure_logo.png',
    [Platform.KIYA]: '/suppliers/kiya_logo.png',
    [Platform.VATEX]: '/suppliers/vatex_logo.png',
    [Platform.ENECO]: '/suppliers/eneco_logo.png',
    [Platform.ANY_INVOICE]: '/suppliers/any_invoice_logo.png',
    [Platform.DRANKDOZIJN]: '/suppliers/drankdozijn_logo.png',
    [Platform.SWINKELS]: '/suppliers/swinkels_logo.png',
    [Platform.BOURGOGNEEXPRESS]: '/suppliers/bourgogneexpress_logo.png',
    [Platform.NOTENFABRIEK]: '/suppliers/notenfabriek_logo.png',
    [Platform.FOURCROY]: '/suppliers/fourcroy_logo.png',
    [Platform.BUONAPPETITO]: '/suppliers/buonappetito_logo.png',
    [Platform.LEXCEPTION]: '/suppliers/lexception_logo.png',
    [Platform.NITROBREW]: '/suppliers/nitrobrew_logo.png',
    [Platform.RIGHTSPIRITS]: '/suppliers/rightspirits_logo.png',
    [Platform.SIDHU]: '/suppliers/sidhu_logo.png',
    [Platform.ILLY]: '/suppliers/illy_logo.png',
    [Platform.DEGROOTEDELGEBAK]: '/suppliers/degrootedelgebak_logo.png',
    [Platform.EUROPASTRY]: '/suppliers/europastry_logo.png',
    [Platform.KAASATELIER]: '/suppliers/kaasatelier_logo.png',
    [Platform.HEINEKEN]: '/suppliers/heineken_logo.png',
    [Platform.PATISSERIEBONDSMOLDERS]: '/suppliers/patisseriebondsmolders_logo.png',
    [Platform.JORDYSBAKERY]: '/suppliers/jordysbakery_logo.png',
    [Platform.SCHMIDTZEEVIS]: '/suppliers/schmidtzeevis_logo.png',
    [Platform.VHCJONGENS]: '/suppliers/vhcjongens_logo.png',
    [Platform.GRAPEDISTRICT]: '/suppliers/grapedistrict_logo.png',
    [Platform.STAFFHORST]: '/suppliers/staffhorst_logo.png',
    [Platform.EXCLUSIVELABELBENELUX]: '/suppliers/exclusivelabelbenelux_logo.png',
    [Platform.MARCKROONWIJN]: '/suppliers/marckroonwijn_logo.png',
    [Platform.LFE]: '/suppliers/lfe_logo.png',
    [Platform.PASTANOBILE]: '/suppliers/pastanobile_logo.png',
    [Platform.MOESTUINVOLLENHOVEN]: '/suppliers/moestuinvollenhoven_logo.png',
    [Platform.JANSONDRANKEN]: '/suppliers/jansondranken_logo.png',
    [Platform.LINDSCHOTENDRINK]: '/suppliers/lindschotendrink_logo.png',
    [Platform.FOODSTEPS]: '/suppliers/foodsteps_logo.png',
    [Platform.BOTTLEBUSINESS]: '/suppliers/bottlebusiness_logo.png',
    [Platform.CEESVANNOORDWIJN]: '/suppliers/ceesvannoordwijn_logo.png',
    [Platform.DRANKENHANDEL]: '/suppliers/drankenhandel_logo.png',
    [Platform.MAISONROUTIN]: '/suppliers/maisonroutin_logo.png',
    [Platform.SANDERSWIJNKOPERS]: '/suppliers/sanderswijnkopers_logo.png',
    [Platform.ALTSEAFOOD]: '/suppliers/altseafood_logo.png',
    [Platform.BJDELOGIE]: '/suppliers/bjdelogie_logo.png',
    [Platform.HOUSEOFCAVIAR]: '/suppliers/houseofcaviar_logo.png',
    [Platform.CLAUDIA]: '/suppliers/claudia_logo.png',
    [Platform.DVINE]: '/suppliers/dvine_logo.png',
    [Platform.VLAAMSCHBROODHUYS]: '/suppliers/vlaamschbroodhuys_logo.png',
    [Platform.BROUWERIJNOORDT]: '/suppliers/brouwerijnoordt_logo.png',
    [Platform.DEKOEKFABRIEK]: '/suppliers/dekoekfabriek_logo.png',
    [Platform.MINZEVENIJS]: '/suppliers/minzevenijs_logo.png',
    [Platform.LOUI]: '/suppliers/loui_logo.png',
    [Platform.KOEKTAILS]: '/suppliers/koektails_logo.png',
    [Platform.CHOCOSEUM]: '/suppliers/chocoseum_logo.png',
    [Platform.NOORDMANWIJNIMPORT]: '/suppliers/noordmanwijnimport_logo.png',
    [Platform.TASTETREE]: '/suppliers/tastetree_logo.png',
    [Platform.DAMMAN]: '/suppliers/damman_logo.png',
    [Platform.KARELVDVORM]: '/suppliers/karelvdvorm_logo.png',
    [Platform.TREUREN]: '/suppliers/treuren_logo.png',
    [Platform.LINSCHOTEN]: '/suppliers/linschoten_logo.png',
    [Platform.CASARON]: '/suppliers/casaron_logo.png',
    [Platform.PROPERPRODUCTS]: '/suppliers/properproducts_logo.png',
    [Platform.NESPRESSO]: '/suppliers/nespresso_logo.png',
    [Platform.VERBUNTVERLINDEN]: '/suppliers/verbuntverlinden_logo.png',
    [Platform.KOBIER]: '/suppliers/kobier_logo.png',
    [Platform.STADSHAVENBROUWERIJ]: '/suppliers/stadshavenbrouwerij_logo.png',
    [Platform.KEMMEWINES]: '/suppliers/kemmewines_logo.png',
    [Platform.MOETHENNESSY]: '/suppliers/moethennessy_logo.png',
    [Platform.JOUWGROENTEMAN]: '/suppliers/jouwgroenteman_logo.png',
    [Platform.DELICATEZZEDITALIA]: '/suppliers/delicatezzeditalia_logo.png',
    [Platform.GOLDTDRINKS]: '/suppliers/goldtdrinks_logo.png',
    [Platform.LAMUSE]: '/suppliers/lamuse_logo.png',
    [Platform.VETLAZY]: '/suppliers/vetlazy_logo.png',
    [Platform.IANENWIJN]: '/suppliers/ianenwijn_logo.png',
    [Platform.LAPROSCIUTTERIA]: '/suppliers/laprosciutteria_logo.png',
    [Platform.WINESPIRITS]: '/suppliers/winespirits_logo.png',
    [Platform.LASALUTE]: '/suppliers/lasalute_logo.jpg',
    [Platform.DEBRUIJN]: '/suppliers/debruijn_logo.png',
    [Platform.VINITES]: '/suppliers/vinites_logo.png',
    [Platform.BOLOMEY]: '/suppliers/bolomey_logo.png',
    [Platform.VLECK]: '/suppliers/vleck_logo.png',
    [Platform.JOKA]: '/suppliers/joka_logo.png',
    [Platform.DEKONINGVLEES]: '/suppliers/dekoningvlees_logo.png',
    [Platform.CORNYBAKERS]: '/suppliers/cornybakers_logo.png',
    [Platform.GIOEMPANADAS]: '/suppliers/gioempanadas_logo.png',
    [Platform.MANMETBRILKOFFIE]: '/suppliers/manmetbrilkoffie_logo.png',
    [Platform.HAVEAFEW]: '/suppliers/haveafew_logo.png',
    [Platform.SLAGERIJOOTEMAN]: '/suppliers/slagerijooteman_logo.png',
    [Platform.AAPNOOTBROOD]: '/suppliers/aapnootbrood_logo.png',
    [Platform.SCANWIC]: '/suppliers/scanwic_logo.png',
    [Platform.DEWEERT]: '/suppliers/deweert_logo.png',
    [Platform.KOMPAAN]: '/suppliers/kompaan_logo.png',
    [Platform.ICEFACTORY]: '/suppliers/icefactory_logo.png',
    [Platform.LINDENHOFF]: '/suppliers/lindenhoff_logo.png',
    [Platform.EBO]: '/suppliers/ebo_logo.png',
    [Platform.FRESHFOOD_DH]: '/suppliers/freshfood_dh.png',
    [Platform.RUYKEN]: '/suppliers/ruyken_logo.png',
    [Platform.FILTA]: '/suppliers/filta_logo.png',
    [Platform.ESPRESSO_SW]: '/suppliers/espresso_sw_logo.png',
    [Platform.VANHATTEN]: '/suppliers/vanhatten.png',
    [Platform.APS]: '/suppliers/aps_logo.png',
    [Platform.SEBCOCKTAILS]: '/suppliers/sebcocktails_logo.png',
    [Platform.BEVENCO]: '/suppliers/bevenco_logo.png',
    [Platform.ILOVECANNOLI]: '/suppliers/ilovecannoli_logo.png',
    [Platform.HORECAGOEDKOOP]: '/suppliers/horecagoedkoop_logo.png',
    [Platform.HORECAKING]: '/suppliers/horecaking_logo.png',
    [Platform.ALBERTHEIN]: '/suppliers/alberthein_logo.png',
    [Platform.TAKEAWARE]: '/suppliers/takeaware_logo.png',
    [Platform.JESSEDELICATESSE]: '/suppliers/jessedelicatesse_logo.png',
    [Platform.PUREMATCHA]: '/suppliers/purematcha_logo.png',
    [Platform.BESTBREADBOBA]: '/suppliers/bestbreadboba_logo.png',
    [Platform.ANDREKERSTENS]: '/suppliers/andrekerstens_logo.png',
    [Platform.FILIUSKAAS]: '/suppliers/filiuskaas_logo.png',
    [Platform.VANILLAVENTURE]: '/suppliers/vanillaventure_logo.png',
    [Platform.GREENFRESHFOOD]: '/suppliers/greenfreshfood_logo.png',
    [Platform.ABINBEV]: '/suppliers/abinbev_logo.png',
    [Platform.DEGOUDENTON]: '/suppliers/degoudenton_logo.png',
    [Platform.VULCAANBIER]: '/suppliers/vulcaanbier_logo.png',
    [Platform.NRBC]: '/suppliers/nrbc_logo.png',
    [Platform.SENZATEA]: '/suppliers/senzatea_logo.png',
    [Platform.HOECKSEVIS]: '/suppliers/hoecksevis_logo.png',
    [Platform.MANETTI]: '/suppliers/manetti_logo.png',
    [Platform.ZEECHOCOLATE]: '/suppliers/zeechocolate_logo.png',
    [Platform.SANTASKOFFIE]: '/suppliers/santaskoffie_logo.png',
    [Platform.FROBEL]: '/suppliers/frobel_logo.png',
    [Platform.IJSENIJSKOUD]: '/suppliers/ijsenijskoud_logo.png',
    [Platform.DEKLOKDRANKEN]: '/suppliers/deklokdranken_logo.png',
    [Platform.RELLMANFOODS]: '/suppliers/rellmanfoods_logo.png',
    [Platform.BERGFOOD]: '/suppliers/bergfood_logo.png',
    [Platform.CAVINOIR]: '/suppliers/cavinoir_logo_nobg.png',
    [Platform.PIEKSMANWIJN]: '/suppliers/pieksmanwijn_logo.png',
    [Platform.DEAMBACHTERIE]: '/suppliers/deambachterie_logo.png',
    [Platform.DRIESSENFOOD]: '/suppliers/driessenfood_logo.png',
    [Platform.DRINKSFROMJAPAN]: '/suppliers/drinksfromjapan_logo.png',
    [Platform.BEMAKERS]: '/suppliers/bemakers_logo.png',
    [Platform.MARIUSWIJNSAKE]: '/suppliers/mariuswijnsake_logo.png',
    [Platform.BARTSBOTTLES]: '/suppliers/bartsbottles_logo.png',
    [Platform.BRONWIJN]: '/suppliers/bronwijn_logo.png',
    [Platform.JANVANAS]: '/suppliers/janvanas_logo.png',
    [Platform.DRTRADING]: '/suppliers/drtrading_logo.png',
    [Platform.DORSTLUST]: '/suppliers/dorstlust_logo.png',
    [Platform.FULLCIRCLE]: '/suppliers/fullcircle_logo.png',
    [Platform.DASBROT]: '/suppliers/dasbrot_logo.png',
    [Platform.QSTA]: '/suppliers/qsta_logo.png',
    [Platform.OLLECOBUNGE]: '/suppliers/ollecobunge_logo.png',
    [Platform.SMITSDELICIOUS]: '/suppliers/smitsdelicious_logo.png',
    [Platform.DUDOK]: '/suppliers/dudok_logo.png',
    [Platform.WESTLANDPEPPERS]: '/suppliers/westlandpeppers_logo.png',
    [Platform.KAAPSEBROUWERS]: '/suppliers/kaapsebrouwers_logo.png',
    [Platform.KOEKELA]: '/suppliers/koekela_logo.png',
    [Platform.VANDEBAKKER]: '/suppliers/vandebakker_logo.png',
    [Platform.STATIONBERGWEG]: '/suppliers/stationbergweg_logo.png',
    [Platform.SAKEBASE]: '/suppliers/sakebase_logo.png',
    [Platform.CELLARMASTERS]: '/suppliers/cellarmasters_logo.png',
    [Platform.DRONK]: '/suppliers/dronk_logo_nobg.png',
    [Platform.INTERFASTFOOD]: '/suppliers/interfastfood_logo.png',
    [Platform.KRAAN]: '/suppliers/kraan_logo.png',
    [Platform.HICRET]: '/suppliers/hicret_logo.png',
    [Platform.KOYLU]: '/suppliers/koylu_logo.png',
    [Platform.AVO]: '/suppliers/avo_logo.png',
    [Platform.IRANBEZORGER]: '/suppliers/ibholland_logo.png',
    [Platform.ANTEP]: '/suppliers/antep_logo.png',
    [Platform.PEEZE]: '/suppliers/peeze_logo.png',
    [Platform.COCKTAILUNLIMITED]: '/suppliers/cocktailunlimited_logo.png',
    [Platform.COOKBOON]: '/suppliers/cookboon_logo.png',
    [Platform.VANLEERSUM]: '/suppliers/vanleersum_logo.png',
    [Platform.BAGHRIR]: '/suppliers/baghrir_logo.png',
    [Platform.LAKARUSCH]: '/suppliers/lakarusch_logo.png',
    [Platform.VHCKREKO]: '/suppliers/vhckreko_logo.png',
    [Platform.FONTIJN]: '/suppliers/fontijn_logo.png',
    [Platform.VERHOEK]: '/suppliers/verhoek_logo.png',
    [Platform.SEAFOODCENTRE]: '/suppliers/seafoodcentre_logo.png',
    [Platform.ALTINPETEK]: '/suppliers/altinpetek_logo.png',
    [Platform.QUEBRACHO]: '/suppliers/quebracho_logo.png',
    [Platform.KOFFIEKOMPAAN]: '/suppliers/koffiekompaan_logo.png',
    [Platform.WIJNHANDELHERMAN]: '/suppliers/wijnhandelherman_logo.png',
    [Platform.DUTCHWASABI]: '/suppliers/dutchwasabi_logo.png',
    [Platform.PROFILGREC]: '/suppliers/profilgrec_logo.png',
    [Platform.JFCHOLLAND]: '/suppliers/jfcholland_logo.png',
    [Platform.JOSGLAS]: '/suppliers/josglas_logo.png',
    [Platform.LOCALHARVEST]: '/suppliers/localharvest_logo.png',
    [Platform.GUILLAUME]: '/suppliers/guillaume_logo.png',
    [Platform.BINSBERGEN]: '/suppliers/binsbergen_logo.png',
    [Platform.HOLLANDVIS]: '/suppliers/hollandvis_logo.png',
    [Platform.EUROSLAGERIJGRIEVING]: '/suppliers/euroslagerijgrieving_logo.png',
    [Platform.QCULINAIR]: '/suppliers/qculinair_logo.png',
    [Platform.KAASFORT]: '/suppliers/kaasfort_logo.png',
    [Platform.NATURALIA]: '/suppliers/naturalia_logo.png',
}

/**
 * Logo map for unsupported/any invoice platforms
 * Maps the unknownSupplierName (cleaned key from backend) to logo paths
 */
const ANY_INVOICE_LOGO_MAP: Record<string, string> = {
    'alberthein': '/suppliers/unsupported/alberthein_logo.png',
    'ziggo': '/suppliers/unsupported/ziggo_logo.png',
    'action': '/suppliers/unsupported/action_logo.png',
    'google': '/suppliers/unsupported/google_logo.png',
    'horecaworld': '/suppliers/unsupported/horecaworld_logo.png',
    'horecarama': '/suppliers/unsupported/horecarama_logo.png',
    'lidl': '/suppliers/unsupported/lidl_logo.png',
    'sidhu': '/suppliers/unsupported/sidhu_logo.png',
}

/**
 * Known misfires from the automated dark-mode logo classifier (logoTreatments.generated.ts).
 * Tile is always the safe fallback here. See spec-logos-and-badges.md Task 2.
 */
const LOGO_TREATMENT_OVERRIDES: Partial<Record<Platform, LogoTreatment>> = {
    [Platform.HEINEKEN]: 'tile',
    [Platform.DUNYONG]: 'tile',
    [Platform.KWASTWIJNKOPERS]: 'tile',
    [Platform.KEMMEWINES]: 'tile',
    // Black line-art logo: stripping the white background leaves the ink invisible on dark and only the
    // enclosed white counters showing, which inverts the wordmark into unreadable outlines.
    [Platform.VANDEBAKKER]: 'tile',
    // Half the mark is a solid BLACK square + black "KAAPSE" wordmark, half is salmon. The salmon pixels
    // push readableFrac over the classifier's threshold, but stripping the white background makes the
    // black square and the whole "KAAPSE" word disappear on dark, leaving disconnected salmon fragments.
    [Platform.KAAPSEBROUWERS]: 'tile',
    // Circular mark split down the middle: a near-black (#1d1d1b) half and a red (#d73a15) half, already
    // on a transparent ground so "stripping" changes nothing. The red half carries the classifier over
    // its threshold, but on the dark canvas the black half vanishes and the mark reads as a lone red
    // crescent instead of the logo.
    [Platform.KOFFIEKOMPAAN]: 'tile',
}

function resolveLogoPath(platform: Platform, unknownSupplierName?: string): string {
    if (platform === Platform.ANY_INVOICE && unknownSupplierName) {
        const anyInvoiceLogo = ANY_INVOICE_LOGO_MAP[unknownSupplierName];
        if (anyInvoiceLogo) {
            return anyInvoiceLogo;
        }
    }

    return logoMap[platform] || '/supplier/default_logo.png'
}

function toDarkLogoPath(path: string): string {
    return path.replace(/\.[^./]+$/, '_dark.png');
}

/**
 * Human-readable supplier name from a platform enum slug ("altseafood" → "Altseafood").
 */
export function formatPlatformName(platform: string): string {
    if (!platform) return '';
    return platform.charAt(0).toUpperCase() + platform.slice(1);
}

/**
 * Dark-mode treatment for a platform's logo: 'raw' (render as-is), 'stripped'
 * (render the _dark.png background-stripped variant), or 'tile' (wrap in the
 * off-white tile via getSupplierLogoTileWrapperClasses()).
 */
export function getPlatformLogoTreatment(platform: Platform, unknownSupplierName?: string): LogoTreatment {
    const override = LOGO_TREATMENT_OVERRIDES[platform];
    if (override) {
        return override;
    }
    const path = resolveLogoPath(platform, unknownSupplierName);
    return logoTreatments[path] ?? 'tile';
}

export function getPlatformLogo(platform: Platform, unknownSupplierName?: string, isDark?: boolean): string {
    const path = resolveLogoPath(platform, unknownSupplierName);

    if (isDark && getPlatformLogoTreatment(platform, unknownSupplierName) === 'stripped') {
        return toDarkLogoPath(path);
    }

    return path;
}

/**
 * Wrapper classes for the 'tile' dark-mode logo treatment: off-white rounded
 * tile so raw white-background logos don't glare on the dark canvas.
 */
export function getSupplierLogoTileWrapperClasses(): string {
    return 'bg-zinc-100 rounded-xl border border-white/10 flex items-center justify-center overflow-hidden'
}

/**
 * Check if an ANY_INVOICE supplier has a logo available
 */
export function hasAnyInvoiceLogo(unknownSupplierName?: string): boolean {
    if (!unknownSupplierName) return false;
    return unknownSupplierName in ANY_INVOICE_LOGO_MAP;
}

/**
 * Logo dimensions for specific ANY_INVOICE suppliers with logos
 */
const ANY_INVOICE_LOGO_DIMENSIONS: Record<string, string> = {
    'alberthein': 'w-4 h-4 rounded-md',
    'ziggo': 'w-8 h-4 rounded-md',
    'action': 'w-9 h-4 rounded-md',
    'google': 'w-8 h-4 rounded-md',
    'horecaworld': 'w-10 h-4 rounded-md',
    'horecarama': 'w-10 h-4 rounded-md',
    'lidl': 'w-4 h-4 rounded-md',
    'sidhu': 'w-10 h-5 rounded-md',
}

export function getPlatformLogoDimensions(platform: Platform, unknownSupplierName?: string): string {
    // For ANY_INVOICE with a specific logo, use its custom dimensions
    if (platform === Platform.ANY_INVOICE && unknownSupplierName && ANY_INVOICE_LOGO_DIMENSIONS[unknownSupplierName]) {
        return ANY_INVOICE_LOGO_DIMENSIONS[unknownSupplierName];
    }

    switch (platform) {
        case Platform.STAFFHORST:
            return "w-14 h-2";
        case Platform.BROUWERIJNOORDT:
            return 'w-3 h-6';
        case Platform.BIDFOOD:
        case Platform.WINTERHALTER:
        case Platform.EUROFINS:
        case Platform.KOELMONTEUR:
        case Platform.UPTA:
        case Platform.VANGELDER:
        case Platform.DRANKDOZIJN:
        case Platform.ALTSEAFOOD:
        case Platform.BJDELOGIE:
        case Platform.KARELVDVORM:
        case Platform.PROPERPRODUCTS:
        case Platform.VERBUNTVERLINDEN:
            return 'w-10 h-4 rounded-md'
        case Platform.FOURCROY: // ~4.6:1 invoice logo
        case Platform.WESTLANDPEPPERS: // ~4.6:1 logo
        case Platform.KOEKELA: // ~4.1:1 logo
        case Platform.SEBCOCKTAILS:
        case Platform.LEXCEPTION:
        case Platform.EUROPASTRY:
        case Platform.ANDREKERSTENS:
        case Platform.PATISSERIEBONDSMOLDERS:
        case Platform.HEINEKEN:
        case Platform.MINZEVENIJS: // 3:1 logo
        case Platform.PASTANOBILE: // Pacenti logo, ~2.65:1
        case Platform.BINSBERGEN: // ~3:1 invoice logo
        case Platform.FRESHFOOD_DH:
        case Platform.FONTIJN: // ~2.56:1 logo
        case Platform.NATURALIA:
        case Platform.INTERFASTFOOD:
        case Platform.IRANBEZORGER:
        case Platform.BAGHRIR:
        case Platform.COOKBOON:
        case Platform.LAKARUSCH:
        case Platform.GRAPEDISTRICT: // ~2.91:1 logo
        case Platform.DUTCHWASABI: // ~2.89:1 logo
        case Platform.BOURGOGNEEXPRESS: // ~3.85:1 wordmark
        case Platform.JFCHOLLAND: // ~4.4:1 logo
        case Platform.QSTA:
        case Platform.VANHATTEN:
        case Platform.NOORDMANWIJNIMPORT: // ~3.8:1 logo
        case Platform.TAKEAWARE:
        case Platform.VLAAMSCHBROODHUYS:
        case Platform.FROBEL:
        case Platform.KOEKTAILS:
        case Platform.ABINBEV:
        case Platform.VULCAANBIER:
        case Platform.VANILLAVENTURE:
        case Platform.DAMMAN:
        case Platform.MOETHENNESSY:
        case Platform.LAMUSE:
        case Platform.VETLAZY:
        case Platform.LAPROSCIUTTERIA:
        case Platform.LASALUTE:
        case Platform.VLECK:
        case Platform.HAVEAFEW:
        case Platform.KOMPAAN:
        case Platform.HORECAGOEDKOOP:
        case Platform.JESSEDELICATESSE:
        case Platform.PUREMATCHA:
        case Platform.SANTASKOFFIE:
        case Platform.MANETTI:
        case Platform.IJSENIJSKOUD:
        case Platform.DEKLOKDRANKEN:
        case Platform.BERGFOOD:
            return 'w-12 h-4 rounded-md'
        case Platform.MOESTUINVOLLENHOVEN: // ~1.67:1 logo
        case Platform.SLIGRO:
        case Platform.ALTINPETEK: // ~2.04:1 logo
        case Platform.KOYLU:
        case Platform.HOLLANDVIS: // ~2.45:1 oval invoice logo
        case Platform.HANOS:
        case Platform.RUYKEN:
        case Platform.FILTA:
        case Platform.VANDEBAKKER: // ~2.25:1 logo
        case Platform.STATIONBERGWEG: // ~1.94:1 logo
        case Platform.SAKEBASE: // ~2.13:1 logo
        case Platform.DUDOK:
        case Platform.OLLECOBUNGE:
        case Platform.SMITSDELICIOUS:
        case Platform.APS:
        case Platform.HORECAKING:
        case Platform.BEVENCO:
        case Platform.BRANDINGCLUB:
        case Platform.ENECO:
        case Platform.WINTAX:
        case Platform.VERISURE:
        case Platform.RIGHTSPIRITS:
        case Platform.SIDHU:
        case Platform.CLAUDIA:
        case Platform.BOTTLEBUSINESS:
        case Platform.DVINE:
        case Platform.TREUREN:
        case Platform.CASARON:
        case Platform.KEMMEWINES:
        case Platform.DELICATEZZEDITALIA:
        case Platform.WINESPIRITS:
        case Platform.BOLOMEY:
        case Platform.DEKONINGVLEES:
        case Platform.SLAGERIJOOTEMAN:
        case Platform.ICEFACTORY:
        case Platform.DEGOUDENTON:
        case Platform.LINDENHOFF:
        case Platform.ZEECHOCOLATE:
            return 'w-10 h-5 rounded-md'
        case Platform.LINDSCHOTENDRINK:
        case Platform.JOSGLAS:
        case Platform.EUROSLAGERIJGRIEVING: // ~1.49:1 official GHV mark
        case Platform.QCULINAIR: // ~1.5:1 invoice logo
        case Platform.SEAFOODCENTRE: // ~1.65:1 logo
        case Platform.CHOCOSEUM:
        case Platform.GNB:
        case Platform.BUONAPPETITO:
        case Platform.HICRET:
        case Platform.AVO:
        case Platform.FIXFISCH:
        case Platform.NOTENFABRIEK:
        case Platform.ZUIVER:
        case Platform.HYSCON:
        case Platform.EVIDES:
        case Platform.KIYA:
        case Platform.VATEX:
        case Platform.DEGROOTEDELGEBAK:
        case Platform.JORDYSBAKERY:
        case Platform.SANDERSWIJNKOPERS:
        case Platform.TASTETREE:
        case Platform.DEBRUIJN:
        case Platform.ILOVECANNOLI:
        case Platform.DEAMBACHTERIE: // ~1.5:1 logo
        case Platform.DRINKSFROMJAPAN: // ~1.5:1 logo
            return 'w-6 h-4 rounded-md'
        case Platform.DUNYONG:
        case Platform.TONKONIJN:
        case Platform.BANKETBAKKERIJ:
        case Platform.OTELLI:
        case Platform.GEBOGELATO:
        case Platform.KWASTWIJNKOPERS:
        case Platform.VINITES:
        case Platform.RUNGIS:
        case Platform.KAASATELIER:
        case Platform.NRBC:
        case Platform.SENZATEA:
        case Platform.HOECKSEVIS:
        case Platform.CEESVANNOORDWIJN:
        case Platform.DRANKENHANDEL:
            return 'w-8 h-4 rounded-md'
        case Platform.JONGVADER:
            return 'w-6 h-3 rounded-md'
        case Platform.DZW:
        case Platform.YAMA:
        case Platform.VINVIN:
        case Platform.NICETOMEAT:
        case Platform.CHEFSFARM:
        case Platform.RIJPELAAL:
        case Platform.DEBERGSECAVE:
        case Platform.WHISKEYSITE:
        case Platform.NITROBREW:
        case Platform.ILLY:
        case Platform.SCHMIDTZEEVIS:
        case Platform.VHCJONGENS:
            return 'w-4 h-4 rounded-md'
        case Platform.CAVINOIR: // ~1.8:1 logo
        case Platform.BEMAKERS: // ~2:1 logo
        case Platform.BRONWIJN: // ~2:1 logo
        case Platform.DRONK: // ~2:1 logo
            return 'w-8 h-4 rounded-md'
        case Platform.MARIUSWIJNSAKE: // ~3:1 logo
        case Platform.DORSTLUST: // ~2.6:1 logo
        case Platform.JANVANAS: // ~3:1 logo
        case Platform.DRTRADING: // ~3.6:1 logo
            return 'w-12 h-4 rounded-md'
        case Platform.RELLMANFOODS: // very wide ~5.2:1 logo
        case Platform.DRIESSENFOOD: // very wide ~5.2:1 logo
            return 'w-16 h-3 rounded-md'
        case Platform.ANTEP: // 0.56 PORTRAIT logo
            return 'w-3 h-5 rounded-md'
        default:
            return 'w-4 h-4 rounded-md'
    }
}



/**
 * Medium logo dimensions for specific ANY_INVOICE suppliers with logos
 */
const ANY_INVOICE_MEDIUM_LOGO_DIMENSIONS: Record<string, string> = {
    'alberthein': 'w-5 h-5 rounded-md',
    'ziggo': 'w-9 h-5 rounded-md',
    'action': 'w-10 h-5 rounded-md',
    'google': 'w-9 h-5 rounded-md',
    'horecaworld': 'w-12 h-5 rounded-md',
    'horecarama': 'w-12 h-5 rounded-md',
    'lidl': 'w-5 h-5 rounded-md',
    'sidhu': 'w-10 h-5 rounded-md',
}

export function getMediumPlatformLogoDimensions(platform: Platform, unknownSupplierName?: string): string {
    // For ANY_INVOICE with a specific logo, use its custom dimensions
    if (platform === Platform.ANY_INVOICE && unknownSupplierName && ANY_INVOICE_MEDIUM_LOGO_DIMENSIONS[unknownSupplierName]) {
        return ANY_INVOICE_MEDIUM_LOGO_DIMENSIONS[unknownSupplierName];
    }

    switch (platform) {
        case Platform.STAFFHORST:
            return "w-16 h-2";
        case Platform.BROUWERIJNOORDT:
            return 'w-4 h-8';
        case Platform.BIDFOOD:
        case Platform.WINTERHALTER:
        case Platform.EUROFINS:
        case Platform.KOELMONTEUR:
        case Platform.UPTA:
        case Platform.DRANKDOZIJN:
        case Platform.ALTSEAFOOD:
        case Platform.BJDELOGIE:
        case Platform.KARELVDVORM:
        case Platform.PROPERPRODUCTS:
        case Platform.VERBUNTVERLINDEN:
            return 'w-12 h-4 rounded-md'
        case Platform.FOURCROY: // ~4.6:1 invoice logo
        case Platform.WESTLANDPEPPERS: // ~4.6:1 logo
        case Platform.KOEKELA: // ~4.1:1 logo
        case Platform.SEBCOCKTAILS:
        case Platform.LEXCEPTION:
        case Platform.EUROPASTRY:
        case Platform.ANDREKERSTENS:
        case Platform.PATISSERIEBONDSMOLDERS:
        case Platform.HEINEKEN:
        case Platform.MINZEVENIJS: // 3:1 logo
        case Platform.PASTANOBILE: // Pacenti logo, ~2.65:1
        case Platform.BINSBERGEN: // ~3:1 invoice logo
        case Platform.FRESHFOOD_DH:
        case Platform.FONTIJN: // ~2.56:1 logo
        case Platform.NATURALIA:
        case Platform.INTERFASTFOOD:
        case Platform.IRANBEZORGER:
        case Platform.BAGHRIR:
        case Platform.COOKBOON:
        case Platform.LAKARUSCH:
        case Platform.GRAPEDISTRICT: // ~2.91:1 logo
        case Platform.DUTCHWASABI: // ~2.89:1 logo
        case Platform.BOURGOGNEEXPRESS: // ~3.85:1 wordmark
        case Platform.JFCHOLLAND: // ~4.4:1 logo
        case Platform.QSTA:
        case Platform.VANHATTEN:
        case Platform.NOORDMANWIJNIMPORT: // ~3.8:1 logo
        case Platform.TAKEAWARE:
        case Platform.VLAAMSCHBROODHUYS:
        case Platform.FROBEL:
        case Platform.KOEKTAILS:
        case Platform.ABINBEV:
        case Platform.VULCAANBIER:
        case Platform.VANILLAVENTURE:
        case Platform.DAMMAN:
        case Platform.MOETHENNESSY:
        case Platform.LAMUSE:
        case Platform.VETLAZY:
        case Platform.LAPROSCIUTTERIA:
        case Platform.LASALUTE:
        case Platform.VLECK:
        case Platform.HAVEAFEW:
        case Platform.KOMPAAN:
        case Platform.HORECAGOEDKOOP:
        case Platform.JESSEDELICATESSE:
        case Platform.PUREMATCHA:
        case Platform.SANTASKOFFIE:
        case Platform.MANETTI:
        case Platform.IJSENIJSKOUD:
        case Platform.DEKLOKDRANKEN:
        case Platform.BERGFOOD:
            return 'w-14 h-5 rounded-md'
        case Platform.VANGELDER:
            return 'w-12 h-5 rounded-md'
        case Platform.MOESTUINVOLLENHOVEN: // ~1.67:1 logo
        case Platform.SLIGRO:
        case Platform.ALTINPETEK: // ~2.04:1 logo
        case Platform.KOYLU:
        case Platform.HOLLANDVIS: // ~2.45:1 oval invoice logo
        case Platform.HANOS:
        case Platform.RUYKEN:
        case Platform.FILTA:
        case Platform.VANDEBAKKER: // ~2.25:1 logo
        case Platform.STATIONBERGWEG: // ~1.94:1 logo
        case Platform.SAKEBASE: // ~2.13:1 logo
        case Platform.DUDOK:
        case Platform.OLLECOBUNGE:
        case Platform.SMITSDELICIOUS:
        case Platform.APS:
        case Platform.HORECAKING:
        case Platform.BEVENCO:
        case Platform.BRANDINGCLUB:
        case Platform.ENECO:
        case Platform.WINTAX:
        case Platform.VERISURE:
        case Platform.RIGHTSPIRITS:
        case Platform.SIDHU:
        case Platform.CLAUDIA:
        case Platform.BOTTLEBUSINESS:
        case Platform.DVINE:
        case Platform.TREUREN:
        case Platform.CASARON:
        case Platform.KEMMEWINES:
        case Platform.DELICATEZZEDITALIA:
        case Platform.WINESPIRITS:
        case Platform.BOLOMEY:
        case Platform.DEKONINGVLEES:
        case Platform.CORNYBAKERS:
        case Platform.SLAGERIJOOTEMAN:
        case Platform.ICEFACTORY:
        case Platform.DEGOUDENTON:
        case Platform.LINDENHOFF:
        case Platform.ZEECHOCOLATE:
            return 'w-10 h-5 rounded-md'
        case Platform.LINDSCHOTENDRINK:
        case Platform.JOSGLAS:
        case Platform.EUROSLAGERIJGRIEVING: // ~1.49:1 official GHV mark
        case Platform.QCULINAIR: // ~1.5:1 invoice logo
        case Platform.SEAFOODCENTRE: // ~1.65:1 logo
        case Platform.CHOCOSEUM:
        case Platform.GNB:
        case Platform.BUONAPPETITO:
        case Platform.HICRET:
        case Platform.AVO:
        case Platform.FIXFISCH:
        case Platform.NOTENFABRIEK:
        case Platform.ZUIVER:
        case Platform.HYSCON:
        case Platform.EVIDES:
        case Platform.KIYA:
        case Platform.VATEX:
        case Platform.DEGROOTEDELGEBAK:
        case Platform.JORDYSBAKERY:
        case Platform.SANDERSWIJNKOPERS:
        case Platform.TASTETREE:
        case Platform.DEBRUIJN:
        case Platform.ILOVECANNOLI:
        case Platform.DEAMBACHTERIE: // ~1.5:1 logo
        case Platform.DRINKSFROMJAPAN: // ~1.5:1 logo
            return 'w-8 h-5 rounded-md'

        case Platform.DUNYONG:
        case Platform.TONKONIJN:
        case Platform.BANKETBAKKERIJ:
        case Platform.OTELLI:
        case Platform.GEBOGELATO:
        case Platform.KWASTWIJNKOPERS:
        case Platform.VINITES:
        case Platform.RUNGIS:
        case Platform.KAASATELIER:
        case Platform.NRBC:
        case Platform.SENZATEA:
        case Platform.HOECKSEVIS:
        case Platform.CEESVANNOORDWIJN:
        case Platform.DRANKENHANDEL:
            return 'w-10 h-5 rounded-md'
        case Platform.JONGVADER:
            return 'w-8 h-4 rounded-md'
        case Platform.DZW:
        case Platform.YAMA:
        case Platform.VINVIN:
        case Platform.NICETOMEAT:
        case Platform.CHEFSFARM:
        case Platform.RIJPELAAL:
        case Platform.DEBERGSECAVE:
        case Platform.WHISKEYSITE:
        case Platform.RIJNMONDGAS:
        case Platform.NITROBREW:
        case Platform.ILLY:
        case Platform.SCHMIDTZEEVIS:
        case Platform.VHCJONGENS:
            return 'w-5 h-5 rounded-md'
        case Platform.CAVINOIR: // ~1.8:1 logo
        case Platform.BEMAKERS: // ~2:1 logo
        case Platform.BRONWIJN: // ~2:1 logo
        case Platform.DRONK: // ~2:1 logo
            return 'w-10 h-5 rounded-md'
        case Platform.MARIUSWIJNSAKE: // ~3:1 logo
        case Platform.DORSTLUST: // ~2.6:1 logo
        case Platform.JANVANAS: // ~3:1 logo
        case Platform.DRTRADING: // ~3.6:1 logo
            return 'w-16 h-5 rounded-md'
        case Platform.RELLMANFOODS: // very wide ~5.2:1 logo
        case Platform.DRIESSENFOOD: // very wide ~5.2:1 logo
            return 'w-20 h-4 rounded-md'
        case Platform.ANTEP: // 0.56 PORTRAIT logo
            return 'w-4 h-7 rounded-md'
        default:
            return 'w-5 h-5 rounded-md'
    }
}

/**
 * Large logo dimensions for specific ANY_INVOICE suppliers with logos
 */
const ANY_INVOICE_LARGE_LOGO_DIMENSIONS: Record<string, string> = {
    'alberthein': 'w-6 h-6 rounded-md',
    'ziggo': 'w-12 h-6 rounded-md',
    'action': 'w-12 h-6 rounded-md',
    'google': 'w-12 h-6 rounded-md',
    'horecaworld': 'w-14 h-6 rounded-md',
    'horecarama': 'w-14 h-6 rounded-md',
    'lidl': 'w-6 h-6 rounded-md',
    'sidhu': 'w-12 h-6 rounded-md',
}

export function getLargePlatformLogoDimensions(platform: Platform, unknownSupplierName?: string): string {
    // For ANY_INVOICE with a specific logo, use its custom dimensions
    if (platform === Platform.ANY_INVOICE && unknownSupplierName && ANY_INVOICE_LARGE_LOGO_DIMENSIONS[unknownSupplierName]) {
        return ANY_INVOICE_LARGE_LOGO_DIMENSIONS[unknownSupplierName];
    }

    switch (platform) {
        case Platform.STAFFHORST:
            return "w-24 h-3";
        case Platform.BROUWERIJNOORDT:
            return 'w-5 h-10';
        case Platform.BIDFOOD:
        case Platform.WINTERHALTER:
        case Platform.EUROFINS:
        case Platform.KOELMONTEUR:
        case Platform.UPTA:
        case Platform.DRANKDOZIJN:
        case Platform.ALTSEAFOOD:
        case Platform.BJDELOGIE:
        case Platform.KARELVDVORM:
        case Platform.PROPERPRODUCTS:
        case Platform.VERBUNTVERLINDEN:
            return 'w-15 h-5 rounded-md'
        case Platform.FOURCROY: // ~4.6:1 invoice logo
        case Platform.WESTLANDPEPPERS: // ~4.6:1 logo
        case Platform.KOEKELA: // ~4.1:1 logo
        case Platform.SEBCOCKTAILS:
        case Platform.LEXCEPTION:
        case Platform.EUROPASTRY:
        case Platform.ANDREKERSTENS:
        case Platform.PATISSERIEBONDSMOLDERS:
        case Platform.HEINEKEN:
        case Platform.MINZEVENIJS: // 3:1 logo
        case Platform.PASTANOBILE: // Pacenti logo, ~2.65:1
        case Platform.BINSBERGEN: // ~3:1 invoice logo
        case Platform.FRESHFOOD_DH:
        case Platform.FONTIJN: // ~2.56:1 logo
        case Platform.NATURALIA:
        case Platform.INTERFASTFOOD:
        case Platform.IRANBEZORGER:
        case Platform.BAGHRIR:
        case Platform.COOKBOON:
        case Platform.LAKARUSCH:
        case Platform.GRAPEDISTRICT: // ~2.91:1 logo
        case Platform.DUTCHWASABI: // ~2.89:1 logo
        case Platform.BOURGOGNEEXPRESS: // ~3.85:1 wordmark
        case Platform.JFCHOLLAND: // ~4.4:1 logo
        case Platform.QSTA:
        case Platform.VANHATTEN:
        case Platform.NOORDMANWIJNIMPORT: // ~3.8:1 logo
        case Platform.TAKEAWARE:
        case Platform.VLAAMSCHBROODHUYS:
        case Platform.FROBEL:
        case Platform.KOEKTAILS:
        case Platform.ABINBEV:
        case Platform.VULCAANBIER:
        case Platform.VANILLAVENTURE:
        case Platform.DAMMAN:
        case Platform.MOETHENNESSY:
        case Platform.LAMUSE:
        case Platform.VETLAZY:
        case Platform.LAPROSCIUTTERIA:
        case Platform.LASALUTE:
        case Platform.VLECK:
        case Platform.HAVEAFEW:
        case Platform.KOMPAAN:
        case Platform.HORECAGOEDKOOP:
        case Platform.JESSEDELICATESSE:
        case Platform.PUREMATCHA:
        case Platform.SANTASKOFFIE:
        case Platform.MANETTI:
        case Platform.IJSENIJSKOUD:
        case Platform.DEKLOKDRANKEN:
        case Platform.BERGFOOD:
            return 'w-18 h-6 rounded-md'
        case Platform.VANGELDER:
            return 'w-12 h-6 rounded-md'
        case Platform.MOESTUINVOLLENHOVEN: // ~1.67:1 logo
        case Platform.SLIGRO:
        case Platform.ALTINPETEK: // ~2.04:1 logo
        case Platform.KOYLU:
        case Platform.HOLLANDVIS: // ~2.45:1 oval invoice logo
        case Platform.HANOS:
        case Platform.RUYKEN:
        case Platform.FILTA:
        case Platform.VANDEBAKKER: // ~2.25:1 logo
        case Platform.STATIONBERGWEG: // ~1.94:1 logo
        case Platform.SAKEBASE: // ~2.13:1 logo
        case Platform.DUDOK:
        case Platform.OLLECOBUNGE:
        case Platform.SMITSDELICIOUS:
        case Platform.APS:
        case Platform.HORECAKING:
        case Platform.BEVENCO:
        case Platform.BRANDINGCLUB:
        case Platform.ENECO:
        case Platform.WINTAX:
        case Platform.VERISURE:
        case Platform.RIGHTSPIRITS:
        case Platform.SIDHU:
        case Platform.CLAUDIA:
        case Platform.BOTTLEBUSINESS:
        case Platform.DVINE:
        case Platform.TREUREN:
        case Platform.CASARON:
        case Platform.KEMMEWINES:
        case Platform.DELICATEZZEDITALIA:
        case Platform.WINESPIRITS:
        case Platform.BOLOMEY:
        case Platform.DEKONINGVLEES:
        case Platform.CORNYBAKERS:
        case Platform.SLAGERIJOOTEMAN:
        case Platform.ICEFACTORY:
        case Platform.DEGOUDENTON:
        case Platform.LINDENHOFF:
        case Platform.ZEECHOCOLATE:
            return 'w-12 h-6 rounded-md'
        case Platform.LINDSCHOTENDRINK:
        case Platform.JOSGLAS:
        case Platform.EUROSLAGERIJGRIEVING: // ~1.49:1 official GHV mark
        case Platform.QCULINAIR: // ~1.5:1 invoice logo
        case Platform.SEAFOODCENTRE: // ~1.65:1 logo
        case Platform.CHOCOSEUM:
        case Platform.GNB:
        case Platform.BUONAPPETITO:
        case Platform.HICRET:
        case Platform.AVO:
        case Platform.FIXFISCH:
        case Platform.NOTENFABRIEK:
        case Platform.ZUIVER:
        case Platform.HYSCON:
        case Platform.EVIDES:
        case Platform.KIYA:
        case Platform.VATEX:
        case Platform.DEGROOTEDELGEBAK:
        case Platform.JORDYSBAKERY:
        case Platform.SANDERSWIJNKOPERS:
        case Platform.TASTETREE:
        case Platform.DEBRUIJN:
        case Platform.ILOVECANNOLI:
        case Platform.DEAMBACHTERIE: // ~1.5:1 logo
        case Platform.DRINKSFROMJAPAN: // ~1.5:1 logo
            return 'w-9 h-6 rounded-md'
        case Platform.DUNYONG:
        case Platform.TONKONIJN:
        case Platform.BANKETBAKKERIJ:
        case Platform.OTELLI:
        case Platform.GEBOGELATO:
        case Platform.KWASTWIJNKOPERS:
        case Platform.VINITES:
        case Platform.RUNGIS:
        case Platform.KAASATELIER:
        case Platform.NRBC:
        case Platform.SENZATEA:
        case Platform.HOECKSEVIS:
        case Platform.CEESVANNOORDWIJN:
        case Platform.DRANKENHANDEL:
            return 'w-12 h-6 rounded-md'
        case Platform.JONGVADER:
            return 'w-10 h-5 rounded-md'
        case Platform.DZW:
        case Platform.YAMA:
        case Platform.VINVIN:
        case Platform.NICETOMEAT:
        case Platform.CHEFSFARM:
        case Platform.RIJPELAAL:
        case Platform.DEBERGSECAVE:
        case Platform.WHISKEYSITE:
        case Platform.RIJNMONDGAS:
        case Platform.NITROBREW:
        case Platform.ILLY:
        case Platform.SCHMIDTZEEVIS:
        case Platform.VHCJONGENS:
            return 'w-6 h-6 rounded-md'
        case Platform.CAVINOIR: // ~1.8:1 logo
        case Platform.BEMAKERS: // ~2:1 logo
        case Platform.BRONWIJN: // ~2:1 logo
        case Platform.DRONK: // ~2:1 logo
            return 'w-12 h-6 rounded-md'
        case Platform.MARIUSWIJNSAKE: // ~3:1 logo
        case Platform.DORSTLUST: // ~2.6:1 logo
        case Platform.JANVANAS: // ~3:1 logo
        case Platform.DRTRADING: // ~3.6:1 logo
            return 'w-20 h-6 rounded-md'
        case Platform.RELLMANFOODS: // very wide ~5.2:1 logo
        case Platform.DRIESSENFOOD: // very wide ~5.2:1 logo
            return 'w-24 h-5 rounded-md'
        case Platform.ANTEP: // 0.56 PORTRAIT logo
            return 'w-5 h-9 rounded-md'
        default:
            return 'w-6 h-6 rounded-md'
    }
}

/**
 * Huge logo dimensions for specific ANY_INVOICE suppliers with logos
 */
const ANY_INVOICE_HUGE_LOGO_DIMENSIONS: Record<string, string> = {
    'alberthein': 'w-36 h-12 rounded-md',
    'ziggo': 'w-24 h-12 rounded-md',
    'action': 'w-24 h-12 rounded-md',
    'google': 'w-24 h-12 rounded-md',
    'horecaworld': 'w-36 h-12 rounded-md',
    'horecarama': 'w-36 h-12 rounded-md',
    'lidl': 'w-24 h-12 rounded-md',
    'sidhu': 'w-24 h-12 rounded-md',
}

export function getHugePlatformLogoDimensions(platform: Platform, unknownSupplierName?: string): string {
    // For ANY_INVOICE with a specific logo, use its custom dimensions
    if (platform === Platform.ANY_INVOICE && unknownSupplierName && ANY_INVOICE_HUGE_LOGO_DIMENSIONS[unknownSupplierName]) {
        return ANY_INVOICE_HUGE_LOGO_DIMENSIONS[unknownSupplierName];
    }

    switch (platform) {
        case Platform.STAFFHORST:
            return "w-48 h-6";
        case Platform.BROUWERIJNOORDT:
            return 'w-9 h-16';
        case Platform.BIDFOOD:
        case Platform.WINTERHALTER:
        case Platform.EUROFINS:
        case Platform.KOELMONTEUR:
        case Platform.UPTA:
        case Platform.DRANKDOZIJN:
        case Platform.ALTSEAFOOD:
        case Platform.BJDELOGIE:
        case Platform.KARELVDVORM:
        case Platform.PROPERPRODUCTS:
        case Platform.VERBUNTVERLINDEN:
            return 'w-36 h-12 rounded-md'
        case Platform.FOURCROY: // ~4.6:1 invoice logo
        case Platform.WESTLANDPEPPERS: // ~4.6:1 logo
        case Platform.KOEKELA: // ~4.1:1 logo
        case Platform.SEBCOCKTAILS:
        case Platform.LEXCEPTION:
        case Platform.EUROPASTRY:
        case Platform.ANDREKERSTENS:
        case Platform.PATISSERIEBONDSMOLDERS:
        case Platform.HEINEKEN:
        case Platform.MINZEVENIJS: // 3:1 logo
        case Platform.PASTANOBILE: // Pacenti logo, ~2.65:1
        case Platform.BINSBERGEN: // ~3:1 invoice logo
        case Platform.FRESHFOOD_DH:
        case Platform.FONTIJN: // ~2.56:1 logo
        case Platform.NATURALIA:
        case Platform.INTERFASTFOOD:
        case Platform.IRANBEZORGER:
        case Platform.BAGHRIR:
        case Platform.COOKBOON:
        case Platform.LAKARUSCH:
        case Platform.GRAPEDISTRICT: // ~2.91:1 logo
        case Platform.DUTCHWASABI: // ~2.89:1 logo
        case Platform.BOURGOGNEEXPRESS: // ~3.85:1 wordmark
        case Platform.JFCHOLLAND: // ~4.4:1 logo
        case Platform.QSTA:
        case Platform.VANHATTEN:
        case Platform.NOORDMANWIJNIMPORT: // ~3.8:1 logo
        case Platform.TAKEAWARE:
        case Platform.VLAAMSCHBROODHUYS:
        case Platform.FROBEL:
        case Platform.KOEKTAILS:
        case Platform.ABINBEV:
        case Platform.VULCAANBIER:
        case Platform.VANILLAVENTURE:
        case Platform.DAMMAN:
        case Platform.MOETHENNESSY:
        case Platform.LAMUSE:
        case Platform.VETLAZY:
        case Platform.LAPROSCIUTTERIA:
        case Platform.LASALUTE:
        case Platform.VLECK:
        case Platform.HAVEAFEW:
        case Platform.KOMPAAN:
        case Platform.HORECAGOEDKOOP:
        case Platform.JESSEDELICATESSE:
        case Platform.PUREMATCHA:
        case Platform.SANTASKOFFIE:
        case Platform.MANETTI:
        case Platform.IJSENIJSKOUD:
        case Platform.DEKLOKDRANKEN:
        case Platform.BERGFOOD:
            return 'w-36 h-12 rounded-md'
        case Platform.VANGELDER:
            return 'w-30 h-12 rounded-md'
        case Platform.MOESTUINVOLLENHOVEN: // ~1.67:1 logo
        case Platform.SLIGRO:
        case Platform.ALTINPETEK: // ~2.04:1 logo
        case Platform.KOYLU:
        case Platform.HOLLANDVIS: // ~2.45:1 oval invoice logo
        case Platform.HANOS:
        case Platform.RUYKEN:
        case Platform.FILTA:
        case Platform.VANDEBAKKER: // ~2.25:1 logo
        case Platform.STATIONBERGWEG: // ~1.94:1 logo
        case Platform.SAKEBASE: // ~2.13:1 logo
        case Platform.DUDOK:
        case Platform.OLLECOBUNGE:
        case Platform.SMITSDELICIOUS:
        case Platform.APS:
        case Platform.HORECAKING:
        case Platform.BEVENCO:
        case Platform.BRANDINGCLUB:
        case Platform.ENECO:
        case Platform.WINTAX:
        case Platform.VERISURE:
        case Platform.RIGHTSPIRITS:
        case Platform.SIDHU:
        case Platform.CLAUDIA:
        case Platform.BOTTLEBUSINESS:
        case Platform.DVINE:
        case Platform.TREUREN:
        case Platform.CASARON:
        case Platform.KEMMEWINES:
        case Platform.DELICATEZZEDITALIA:
        case Platform.WINESPIRITS:
        case Platform.BOLOMEY:
        case Platform.DEKONINGVLEES:
        case Platform.CORNYBAKERS:
        case Platform.SLAGERIJOOTEMAN:
        case Platform.ICEFACTORY:
        case Platform.DEGOUDENTON:
        case Platform.LINDENHOFF:
        case Platform.ZEECHOCOLATE:
            return 'w-24 h-12 rounded-md'
        case Platform.LINDSCHOTENDRINK:
        case Platform.JOSGLAS:
        case Platform.EUROSLAGERIJGRIEVING: // ~1.49:1 official GHV mark
        case Platform.QCULINAIR: // ~1.5:1 invoice logo
        case Platform.SEAFOODCENTRE: // ~1.65:1 logo
        case Platform.CHOCOSEUM:
        case Platform.GNB:
        case Platform.BUONAPPETITO:
        case Platform.HICRET:
        case Platform.AVO:
        case Platform.FIXFISCH:
        case Platform.NOTENFABRIEK:
        case Platform.ZUIVER:
        case Platform.HYSCON:
        case Platform.EVIDES:
        case Platform.KIYA:
        case Platform.VATEX:
        case Platform.DEGROOTEDELGEBAK:
        case Platform.JORDYSBAKERY:
        case Platform.SANDERSWIJNKOPERS:
        case Platform.TASTETREE:
        case Platform.DEBRUIJN:
        case Platform.ILOVECANNOLI:
        case Platform.DEAMBACHTERIE: // ~1.5:1 logo
        case Platform.DRINKSFROMJAPAN: // ~1.5:1 logo
            return 'w-18 h-12 rounded-md'
        case Platform.DUNYONG:
        case Platform.TONKONIJN:
        case Platform.BANKETBAKKERIJ:
        case Platform.OTELLI:
        case Platform.JONGVADER:
        case Platform.GEBOGELATO:
        case Platform.KWASTWIJNKOPERS:
        case Platform.VINITES:
        case Platform.RUNGIS:
        case Platform.KAASATELIER:
        case Platform.NRBC:
        case Platform.SENZATEA:
        case Platform.HOECKSEVIS:
        case Platform.CEESVANNOORDWIJN:
        case Platform.DRANKENHANDEL:
            return 'w-24 h-12 rounded-md'
        case Platform.DZW:
        case Platform.YAMA:
        case Platform.VINVIN:
        case Platform.NICETOMEAT:
        case Platform.CHEFSFARM:
        case Platform.RIJPELAAL:
        case Platform.DEBERGSECAVE:
        case Platform.WHISKEYSITE:
        case Platform.RIJNMONDGAS:
        case Platform.NITROBREW:
        case Platform.ILLY:
        case Platform.SCHMIDTZEEVIS:
        case Platform.VHCJONGENS:
            return 'w-14 h-14 rounded-md'
        case Platform.CAVINOIR: // ~1.8:1 logo
        case Platform.BEMAKERS: // ~2:1 logo
        case Platform.BRONWIJN: // ~2:1 logo
        case Platform.DRONK: // ~2:1 logo
            return 'w-24 h-12 rounded-md'
        case Platform.MARIUSWIJNSAKE: // ~3:1 logo
        case Platform.DORSTLUST: // ~2.6:1 logo
        case Platform.JANVANAS: // ~3:1 logo
        case Platform.DRTRADING: // ~3.6:1 logo
            return 'w-36 h-12 rounded-md'
        case Platform.RELLMANFOODS: // very wide ~5.2:1 logo
        case Platform.DRIESSENFOOD: // very wide ~5.2:1 logo
            return 'w-36 h-7 rounded-md'
        case Platform.ANTEP: // 0.56 PORTRAIT logo
            return 'w-10 h-18 rounded-md'
        default:
            return 'w-14 h-14 rounded-md'
    }
}

export function filterProducts(products: Product[], filterValue: FilterOption): Product[] {
    if (filterValue === 'all') return products
    if (filterValue === 'food') return products.filter(p => p.category !== "NON_FOOD")
    if (filterValue === 'nonFood') return products.filter(p => p.category === "NON_FOOD")
    return products
}


let savedY = 0
export function saveScrollY(y: number) { 
    savedY = y 
}

export function getScrollY() {
    return savedY
}

export function formatDate(iso: string): string {
    const date = new Date(iso);
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export function formatOrderDate(date: string | Date): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    const day   = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year  = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  export function formatDateLong(date: string | Date): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    const [day, month, year] = dfnsFormat(d, 'dd MMMM yyyy').split(' ');
    return `${day} ${month.toLowerCase()} ${year}`;
  }